<template>
  <div>
    <app-login> </app-login>
  </div>
</template>

<script>
import Login from "@/components/BookingApp/UserView/Login/Login";
export default {
  name: "Login",
  components: {
    appLogin: Login,
  },
};
</script>

<style>
</style>